<div class="cookie-law">
  <div class="cookie-law--main">
    <div id="cookie-law--message">{ $_('cookie-law.message', 'Wir verwenden Cookies, damit die Webseite korrekt funktioniert.') }</div>
  </div>

  <div class="cookie-law--config pt-1">
  </div>

  <div class="cookie-law--submit pt-2">
    <a href="#" on:click={submitAndAllowAll}><span id="cookie-law--submit--all" class="btn btn-primary btn-sm ml-3">{ $_('cookie-law.submit.all', 'Empfohlene Einstellungen speichern') }</span></a>
    <a href="#" on:click={submitAndAllowNone}><span id="cookie-law--submit--preferred" class="btn btn-cta btn-primary btn-sm ml-3" >{ $_('cookie-law.submit.none', 'Einstellungen speichern') }</span></a>
    <a href="#" on:click={detailed}><span id="cookie-law--submit--configure" class="btn btn-cta btn-secondary btn-sm ml-3" >{ $_('cookie-law.submit.detailed', 'Einstellungen speichern') }</span></a>
  </div>
</div>

<script>
    import { createEventDispatcher } from "svelte";
    import { _ } from "@/frontend/lib/translations";
    export let statistics = true;
    export let error = true;

    import AnalyticsManager from "./v4_analytics";
    import { selectVendors } from "./v4";

    const dispatch = createEventDispatcher();

    const onerror = (e) => window.reportError(e, {telemetry: false});

    function submitAndAllowAll() {
        AnalyticsManager.setConfigured();
        AnalyticsManager.update(AnalyticsManager.vendors.map(v => v.id)).catch(onerror);
        dispatch("submit", {});
    }
    function submitAndAllowNone() {
        AnalyticsManager.setConfigured();
        AnalyticsManager.update(AnalyticsManager.vendors.filter(v => v.strictlyRequired).map(v => v.id)).catch(onerror);
        dispatch("submit", {});
    }
    function detailed() {
        dispatch("submit", {});
        selectVendors().catch(window.reportError);
    }

</script>
